<div class="whole-page" *ngIf="showSidebar; else login">
    <div class="ui top attached demo menu">
        <a class="item" (click)="sidebar.toggle()">
            <i class="sidebar icon"></i>
        </a>
        <div class="home" (click)="homeClicked()">
            <img src="../assets/logo.png" class="logo">
            <h3 *ngIf="!attendanceService.getIsMobile">
                Attendance Management System
            </h3>
        </div>


        <div class="right menu">
            <div class="item" style="color:gainsboro">{{user ? user.display_name : ''}}</div>
            <div class="app-list">
                <ng-template let-popup #popupTemplate>
                    <!-- <div class="header">Rating</div> -->
                    <div class="header">
                        <div class="app-list-container">
                            <div class="app-item" *ngFor="let app of apps">
                                <div class="app-item-container" *ngIf="app.access_permit">
                                    <a href="{{app.url}}" target="_blank">
                                        <img src="{{app.logo}}" alt="{{app.name}}">
                                        <h6>{{app.name}}</h6>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <div class="icon-wrapper" suiPopup [popupPlacement]="'bottom right'" [popupTemplate]="popupTemplate"
                    popupTrigger="outsideClick">
                    <img class="app-list-icon" src="../assets/app-list.svg" alt="App list">
                </div>
            </div>
            <a class="item" (click)="logout()"><i class="sign out alternate icon"></i></a>
        </div>
    </div>

    <sui-sidebar-container class="ui bottom attached segment">
        <sui-sidebar class="inverted vertical" transition="uncover" #sidebar>
            <a class="item" routerLink="/attendance-record" (click)="closeSidebar(sidebar)">出勤簿/ Attendance Record</a>
            <a class="item" routerLink="/attendance-status" (click)="closeSidebar(sidebar)">勤務状況/ Attendance Status</a>
            <a class="item" routerLink="/workrec-list" *ngIf="isAdmin || isLeader"
                (click)="closeSidebar(sidebar)">出勤簿一覧/ Records List</a>
            <a class="item" routerLink="/alert-application" *ngIf="isAdmin || isLeader"
                (click)="closeSidebar(sidebar)">アラート＆修正申請一覧/ Alert and Application List</a>
            <a class="item" routerLink="/reports" *ngIf="isAdmin || isLeader" (click)="closeSidebar(sidebar)">リポート/
                Reports</a>
            <a class="item" routerLink="/unavailable-list" target="_blank" (click)="closeSidebar(sidebar)">離席状況/
                Unavailable List</a>
            <a class="item" routerLink="/basic-settings" *ngIf="isAdmin" (click)="closeSidebar(sidebar)">管理者設定/ Basic
                Registration Settings</a>
            <a class="item" routerLink="/template-settings" *ngIf="isAdmin" (click)="closeSidebar(sidebar)">ひな形設定/
                Template Settings</a>
            <a class="item" routerLink="/indi-settings" *ngIf="isAdmin" (click)="closeSidebar(sidebar)">個別設定/ Individual
                Settings</a>
            <!-- <a class="item" routerLink="/dashboard" *ngIf="isAdmin" (click)="closeSidebar(sidebar)">Dashboard</a> -->
            <a class="item" routerLink="/timestamp-cebu" *ngIf="showTimestampCebu || (showTimestampCebu && isAdmin)"
                (click)="closeSidebar(sidebar)">Cebu Staff Timestamp</a>
            <!-- <a class="item" routerLink="/breaktime-cebu" *ngIf="showTimestampCebu || (showTimestampCebu && isAdmin)" (click)="closeSidebar(sidebar)">Cebu Staff Breaktimer</a> -->
            <a class="item" routerLink="/cebu-vacations"
                *ngIf="isAdmin || (showTimestampCebu && isAdmin) || (showTimestampCebu && isLeader)"
                (click)="closeSidebar(sidebar)">CEBUスタッフ有休管理/ Cebu Staff Leave Management</a>
            <a class="item" href="https://request.gm-system.net/#/top-page" target="_blank"
                (click)="closeSidebar(sidebar)">申請システム/ Apply system</a>
        </sui-sidebar>
        <sui-sidebar-sibling class="content" [isDimmedWhenVisible]="false">
            <div class="pages">
                <router-outlet></router-outlet>
            </div>
        </sui-sidebar-sibling>
    </sui-sidebar-container>
</div>

<ng-template #login>
    <router-outlet></router-outlet>
</ng-template>

<!-- Update notification for morning meeting -->
<div class="ui floating success message" [class.hide_notif]="!morning_meeting_notif">
    <i class="close icon"></i>
    <div class="header notif">
        Update successful
    </div>
</div>